// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__14PGw","inner":"Footer_inner__230XP"};